window.addEventListener("DOMContentLoaded", function() {
  var body = document.getElementsByTagName('body')[0];
  if (!body.classList.contains('i4-template--edit-mode')) {
    initAosScroll();
  }
});


function initAosScroll() {
  // aos init options
  let aosOptions = {
    // Global settings:
    disable: 'phone', // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
    initClassName: 'aos-init', // class applied after initialization
    animatedClassName: 'aos-animate', // class applied on animation
    useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
    disableMutationObserver: false, // disables automatic mutations' detections (advanced)
    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    offset: 0, // offset (in px) from the original trigger point
    delay: 500, // values from 0 to 3000, with step 50ms
    duration: 500, // values from 0 to 3000, with step 50ms
    easing: 'ease-out', // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
  };

  // load aos css
  let link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = 'https://unpkg.com/aos@2.3.1/dist/aos.css';
  document.head.appendChild(link);

  // load aos js and init aos once script loaded
  let script = document.createElement('script');
  script.onload = function () {
    AOS.init(aosOptions);

    // refresh on full page load
    document.addEventListener('load', function () {
      AOS.refresh();
    });

    // refresh after each lazyloaded image
    document.addEventListener('i4-lazyload', function () {
      AOS.refresh();
    });
  };

  script.src = 'https://unpkg.com/aos@next/dist/aos.js';
  document.head.appendChild(script);
}







